<div class='SearchForContact'>
  <div *ngIf='componentReady && messages && messages.length > 0' class='SearchForContact-content'>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Message
        </mat-panel-title>
        <mat-panel-description>Click to expand the message</mat-panel-description>
      </mat-expansion-panel-header>
      <app-message-viewer
        *ngFor='let message of messages'
        [message]='message'
        [sessionData]='sessionData'></app-message-viewer>
    </mat-expansion-panel>
  </div>
  <div *ngIf='matchedContact' class='SearchForContact-matched container mt-3 d-flex flex-column'>
    <div class='mb-3'>
      <mat-label><b>Select contact - Found tracking tag</b></mat-label>
    </div>
    <div class='d-flex flex-row justify-content-between align-items-center'>
      <p class='mb-0'>{{ matchedContact.firstname }} {{ matchedContact.lastname }} ({{ matchedContact.email }})</p>
      <app-button
        [Click]='selectMatchedContactButton.onClick'
        [color]='selectMatchedContactButton.color'
        [size]='selectMatchedContactButton.size'
        [text]='selectMatchedContactButton.text'
      ></app-button>
    </div>
  </div>
  <div class='SearchForContact-search container mt-3'>
    <mat-label><b>Search for existing contact</b></mat-label>
    <app-text-field
      (changes)='onFieldChange($event)'
      [minUpdateCount]='1'
      [value]='searchString'
      placeholder='Search for existing contact'></app-text-field>
  </div>
  <div class='SearchForContact-table container mt-3'>
    <ng-container *ngIf='tableReady'>
      <app-table
        #tableComponent
        *ngIf='tableReady'
        [columns]='tableColumns'
        [dataSourceParams]='tableDataSourceParams'
        [dataSource]='dataSource'></app-table>
    </ng-container>
  </div>
</div>
